



































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { deviceServer, doublePrevention } from '@/api/installServer';
import { arrayToTree } from '@/util/array';

@Component
export default class AddDeviceDialog extends Vue {
  visible = false;
  title = '新增设备';
  // 表单数据对象
  formData: any = {};
  private formRules = {
    deviceNum: [
      { required: true, message: '请填写设备数量' },
      { type: 'number', message: '设备数量必须为数字值' },
    ],
    deviceName: [{ required: true, message: '请填写设备名称' }],
    isSpecialDevice: [{ required: true, message: '请填写设备名称' }],
    isImportantDevice: [{ required: true, message: '请填写设备名称' }],
  };

  showDialog(data: any) {
    this.visible = true;
  }

  hideDialog() {
    this.formData = {};
    this.visible = false;
    (this.$parent as any).getAllData();
  }

  submitForm() {
    (this.$refs.form as any).validate((valid: any) => {
      if (!valid) {
        return;
      } else {
        deviceServer.addDevice({ ...this.formData }).then((res: any) => {
          // console.log(res);
          if (res.code === '200') {
            this.$message.success('成功新增设备！');
            this.hideDialog();
          } else {
            this.$message.warning(res.msg);
          }
        });
      }
    });
  }
}
